'use strict';

const inputChat = document.querySelector("[data-js='chat-input']")

var chatToken = global.chatToken;
if (typeof chatToken == 'undefined') {
	var chatToken = cookieManager.getCookie('chatToken');
}

global.readEnabled = true;
global.readEnabled2 = true;
var exclusions = [];
var lastMessageTimeString = '0';

var self = module.exports = {

	getMessageHtml: function () {
		return '' +
			'<div id="chat-message-[##ID##]" class="[##CLASS_USER_TYPE##] bg-white/80 duration-300 ease-out-expo opacity-0 py-4 rounded-t-3xl scale-0 transition">' +
			'<p class="font-poppins font-normal text-black text-16-24">' +
			'[##MESSAGE##]' +
			'</p>' +
			'</div>'
			;
	},

	generateToken: function () {
		return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	},

	renewChatToken: function () {
		if (chatToken) {
			cookieManager.setCookie('chatToken', chatToken, 2);
		} else {
			chatToken = self.generateToken();
			cookieManager.setCookie('chatToken', chatToken, 2);
		}
	},

	init: function () {

		if (document.querySelector("[data-js='chat-open']")) {
			document.querySelector("[data-js='chat-open']").addEventListener("click", () => {
				self.read();

				document.querySelector("[data-js='chat']").classList.remove("opacity-0", "pointer-events-none");
				document.querySelector("[data-js='chat-keyboard']").classList.remove("translate-y-full");
			});
		}

		document.querySelector("[data-js='chat-close']").addEventListener("click", () => {
			document.querySelector("[data-js='chat']").classList.add("opacity-0", "pointer-events-none");
			document.querySelector("[data-js='chat-keyboard']").classList.add("translate-y-full");
		});

		document.querySelector("[data-js='chat-submit']").addEventListener("click", () => {
			let message = inputChat.value;
			self.send(message);
		});

		inputChat.addEventListener('keypress', (event) => {
			let message = inputChat.value;

			if (event.key === 'Enter') {
				self.send(message);
			}
		});
	
		inputChat.addEventListener('input', () => {
			inputChat.style.height = 'auto';
			const newHeight = Math.min(inputChat.scrollHeight, 160);
			inputChat.style.height = newHeight + 'px';
			inputChat.style.overflowY = inputChat.scrollHeight > 160 ? 'auto' : 'hidden';
		});

		self.renewChatToken();

		if (typeof adminUsername != 'undefined' && adminUsername) {
			self.read();
		}
	},

	cleanInput: function () {
		inputChat.value = '';
	},

	getCurrentTimeString: function () {
		var currentdate = new Date();
		return '' +
			(currentdate.getFullYear()) +
			(currentdate.getMonth() + 1 < 10 ? '0' + (currentdate.getMonth() + 1) : currentdate.getMonth() + 1) +
			(currentdate.getDate() < 10 ? '0' + currentdate.getDate() : currentdate.getDate()) +
			(currentdate.getHours()) +
			(currentdate.getMinutes())
			;
	},

	buildMessageHtml: function (id, message, isCustomer) {
		var html = self.getMessageHtml();
		html = html.replace('[##ID##]', id);
		html = html.replace('[##MESSAGE##]', message);
		html = html.replace('[##CLASS_USER_TYPE##]', (isCustomer ? 'ml-[20%] origin-bottom-right pr-8 pl-4 rounded-bl-3xl' : 'mr-[20%] origin-bottom-left pl-8 pr-4 rounded-br-3xl'));
		return html;
	},

	appendMessage: function (id, html) {
		document.querySelector("[data-js='chat-messages']").insertAdjacentHTML('beforeend', html);

		setTimeout(function () {
			if(document.querySelector("[data-js='chat-messages'] #chat-message-" + id)) {
				document.querySelector("[data-js='chat-messages'] #chat-message-" + id).classList.remove('opacity-0', 'scale-0');
				document.querySelector("[data-js='chat-messages'] #chat-message-" + id).classList.add('opacity-100', 'scale-100');
			}
		}, 100);

		document.querySelector("[data-js='chat-scroll']").scrollTo({
			top: document.querySelector("[data-js='chat-scroll']").scrollHeight,
			behavior: "smooth"
		});
	},

	read: function () {
		setTimeout(function () {

			// console.log('global.readEnabled', global.readEnabled, 'global.readEnabled2', global.readEnabled2);

			// console.log(global.readEnabled, global.readEnabled2);

			if (global.readEnabled && global.readEnabled2) {
				global.readEnabled2 = false;
				$.post('/chat/read', {
					token: chatToken,
					exclusions: exclusions
				}, function (data) {
					if (global.readEnabled) {
						exclusions = data.exclusions;
						for (var i = 0; i < data.messages.length; i++) {
							var html = self.buildMessageHtml(data.messages[i].id, data.messages[i].message, data.messages[i].isCustomer);
							self.appendMessage(data.messages[i].id, html);
						}
						global.readEnabled2 = true;
					} else {
						global.readEnabled2 = true;
					}
				}).fail(function (data) {
					global.readEnabled2 = true;
					/**
					 * @Todo: gestire errore generico
					 */
				});
			}
			self.read();
		}, 1500);
	},

	send: function (message) {

		if (message) {

			// console.log('exclusions', exclusions);

			// chatToken = cookieManager.getCookie('chatToken');

			global.readEnabled = false;

			self.cleanInput();

			// console.log(self.getCurrentTimeString(), lastMessageTimeString);

			var temporaryMessageId = 'tmp' + self.generateToken();

			var html = self.buildMessageHtml(temporaryMessageId, message, (typeof adminUsername == 'undefined' || adminUsername == ''));
			self.appendMessage(temporaryMessageId, html);

			$.post('/chat/write', {
				token: chatToken,
				message: message,
				isCustomer: ((typeof adminUsername == 'undefined' || adminUsername == '') ? 1 : 0),
				copiaincollaUser: (typeof adminUsername == 'undefined' ? '' : adminUsername),
				notification: ((typeof adminUsername == 'undefined' || adminUsername == '') ? ((parseInt(self.getCurrentTimeString()) - parseInt(lastMessageTimeString)) > 10 ? 1 : 0) : 0)
			}, function (data) {

				lastMessageTimeString = parseInt(self.getCurrentTimeString());

				if (data.result) {
					exclusions.push(data.id);

					document.querySelector("[data-js='chat-messages'] #chat-message-" + temporaryMessageId).id = 'chat-message-' + data.id;
					document.querySelector("[data-js='chat-messages'] #chat-message-" + data.id).classList.add('opacity-100', 'scale-100');
				} else {
					document.querySelector("[data-js='chat-messages'] #chat-message-" + temporaryMessageId).classList.add('opacity-20', 'scale-100');
				}
				setTimeout(function () {
					global.readEnabled = true;
				}, 1000);

			}).fail(function () {
				document.querySelector("[data-js='chat-messages'] #chat-message-" + temporaryMessageId).classList.add('opacity-20', 'scale-100');
				global.readEnabled = true;
			});
		}
	}
};

self.init();
